<template></template>

<script>
	import libraryItem from '../library-item'

	export default {
		mixins: [libraryItem],
		mounted() {
			this.$nextTick(this.onResize)
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/CollectionRendered.vue